import 'babel-polyfill';
import React from 'react';
import qs from 'query-string';
import axios from 'axios';
import { merge, evolve, equals, defaultTo } from 'ramda';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ConnectedRouter } from 'react-router-redux';
import { MuiThemeProvider as V0MuiThemeProvider } from 'material-ui';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'; // v1.x
import theme, { muiTheme } from './theme';
import App from './components/App';
import UnderConstruction from './components/UnderConstruction';
import configureStore, { history } from './configureStore';
import { initialState } from './reducers/options';

import './css/basscss-custom.css';
import './css/index.css';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

const themeV1 = createMuiTheme({
  palette: {
    primary: {
      light: '#ffdd4b',
      main: '#ff6d00',
      dark: '#c67c00',
    },
    secondary: {
      light: '#e0e0e0',
      main: '#aeaeae',
      dark: '#d8d8d8',
    },
  },
});

const userOptions = evolve(
  {
    sortReversed: equals('true'),
    settingsBar: equals('true'),
    exportIncludeDataset: equals('true'),
    exportIncludeMetadata: equals('true'),
    selectedCitiesIds: defaultTo([]),
    selectedCensusTractsIds: defaultTo([]),
  },
  qs.parse(window.location.search, {
    arrayFormat: 'brackets',
  }),
);

ReactDOM.render(
  <Provider
    store={configureStore({ options: merge(initialState, userOptions) })}
  >
    <ConnectedRouter history={history}>
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={themeV1}>
          <V0MuiThemeProvider muiTheme={muiTheme}>
            {process.env.REACT_APP_UNDER_CONSTRUCTION ? (
              <UnderConstruction />
            ) : (
              <App />
            )}
          </V0MuiThemeProvider>
        </MuiThemeProvider>
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js